

import { useState } from "react";
import ProfileService from "../service/api/profile";


export const useProfile = () => {

    const [loading, setLoading] = useState(false);
    const [profileList, setProfileList] = useState(null);
    const [isUpdating, setIsUpdating] = useState(false)
    const [profileDetails, setProfileDetails] = useState(null)
    const [loadingDetails, setLoadingDetails] = useState(false)

    const getUserProfile = (parameters) => {
        setLoading(true)
        ProfileService.getUserProfile(parameters).then((res)=>{
            console.log('viewUser xxxxxxxxxxxxx', res)
            setProfileList(res.data.data)
            setLoading(false)
        }).catch((err)=>{
            console.log('errrr', err)
            setLoading(false)
        })
    }

    const updateProfile = (parameters, payload) => {
        setIsUpdating(true)
        ProfileService.updateProfile(parameters, payload).then((res)=>{
            console.log('viewUser xxxxxxxxxxxxx', res)
            setIsUpdating(false)
        }).catch((err)=>{
            console.log('errrr', err)
            setIsUpdating(false)
        })
    }

    const viewUserProfile = (parameters) => {
        setLoadingDetails(true)
        ProfileService.viewUserProfile(parameters).then((res) => {
            console.log('view user profile resss', res)
            setLoadingDetails(false)
            setProfileDetails(res.data.data)
        }).catch((err)=>{
            console.log('errrr', err)
            setLoadingDetails(false)
        })
    }

    return{
       loading, getUserProfile, profileList, updateProfile, isUpdating, viewUserProfile, profileDetails, loadingDetails
    }
}